import styled, { css } from 'styled-components'
import { PageTitle } from 'styles/components'
import { MenuOptions, MenuOption } from 'styles/components'
import { Link } from 'react-router-dom'

export const Bar = styled.header`
  position: relative;
  z-index: 950;
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(200px, 440px) auto;
  align-items: center;
  gap: 16px;
  width: 100%;
  min-height: 56px;
  padding: 0 16px 0 12px;
  background: linear-gradient(90deg, #096dd9 0%, #1f63e3 55%, #1770c1 100%);
  box-shadow: inset 0 -1px 0 rgba(255, 255, 255, 0.12), 0 1px 2px rgba(9, 9, 11, 0.08);
  font-family: 'Plus Jakarta Sans', 'Poppins', sans-serif;

  ${({ isStaging }) =>
    isStaging &&
    css`
      background: linear-gradient(90deg, #673ab7 0px, #c00f4b);
    `}

  ${({ mode }) =>
    mode === 'mobile' &&
    css`
      grid-template-columns: minmax(0, 1fr) auto;
      padding: 0 10px 0 12px;
    `}

  .ps-bar-left {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
  }

  .ps-bar-center {
    display: flex;
    justify-content: center;
    min-width: 0;
  }

  .ps-bar-right {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 6px;
    min-width: 0;
  }
`

export const OptionsWrapper = styled(MenuOptions)`
  position: absolute;
  top: 70px;
  left: 30px;
  width: 15%;
  z-index: 999;

  ${({ top }) =>
    top &&
    css`
      top: ${top}px;
    `}

  ${({ autoWidth }) =>
    autoWidth &&
    css`
      width: auto;
    `}

  ${({ left }) =>
    left &&
    css`
      left: ${left}px;
    `}

  ${({ right }) =>
    right &&
    css`
      right: ${right}px;
      left: auto;
    `}

  ${({ inline }) =>
    inline &&
    css`
      display: inline-table;
    `}

  ${OptionsBase} {
    ${({ autoWidth }) =>
      autoWidth &&
      css`
        width: 100%;
        max-height: 35vw;
        overflow: auto;
      `}
  }

  ${({ isMobile, isOpen, isSubMenu }) =>
    isMobile &&
    isOpen &&
    !isSubMenu &&
    css`
      display: block !important;
      position: absolute !important;
      height: 97vh;
      align-items: baseline;
    `}

  ${({ isMobile, isOpen, isSubMenu }) =>
    isMobile &&
    isOpen &&
    isSubMenu &&
    css`
      display: flex !important;
      position: initial !important;
    `}

  ${({ isMobile, marginLeft }) =>
    isMobile &&
    marginLeft &&
    css`
      margin-left: -30px;
      margin-top: 10px;
    `}

  ${({ isMobile }) =>
    isMobile &&
    css`
      position: initial;
      width: 100vw;
      display: none;
      flex-wrap: wrap;

      ${OptionsBase} {
        flex: 12 0 100%;
        position: initial;

        $:after {
          content: '\f107' !important;
        }
      }
    `}

  ${({ ordering }) =>
    ordering &&
    css`
      ${OptionsBase} {
        $:after {
          content: '\f338' !important;
          display: block;
        }
      }
    `}

    ${({ width }) =>
    width &&
    css`
      width: ${width}px !important;
    `}
`

export const OptionsBase = styled(MenuOption)`
  min-width: auto;
  justify-content: start;
  color: ${({ theme }) => theme.colors.textColor};

  ${({ hasSubMenu }) =>
    hasSubMenu &&
    css`
      justify-content: space-between;

      &:after {
        display: block;
      }
    `}

  ${({ divisor }) =>
    divisor &&
    css`
      border-top: 1px solid rgba(0, 0, 0, 0.1);
    `}

  ${({ end }) =>
    end &&
    css`
      justify-content: flex-end;
    `}

  ${({ arrowLeft }) =>
    arrowLeft &&
    css`
      &:before {
        font-family: 'Font Awesome 5 Free';
        content: '\f104';
        margin-right: 15px;
        font-weight: bold;
      }
    `}

  ${({ header }) =>
    header &&
    css`
      font-weight: bold;
      cursor: auto;
    `}

  ${({ isChildren }) =>
    isChildren &&
    css`
      padding-left: 40px;
      &:hover {
        filter: contrast(0.5);
      }
    `}

  ${({ justify }) =>
    justify &&
    css`
      justify-content: ${justify};
    `}

  ${({ isActive }) =>
    isActive &&
    css`
      background: ${(props) => props.theme.colors.backgroundContainerHover};
    `};

  ${({ pointer }) =>
    pointer &&
    css`
      cursor: pointer;
    `};
`

export const Options = styled.div``

export const Logo = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.16);

  img {
    width: 15px;
    height: 17px;
  }
`

export const Profile = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-self: end;
  min-width: 0;

  /* em telas menores fica só a foto (nome e ambiente aparecem no menu da conta) */
  @media (max-width: 1099px) {
    .ps-profile-text {
      display: none !important;
    }
  }
`

export const Label = styled(PageTitle)`
  line-height: 18px;
  font-family: 'Plus Jakarta Sans', 'Poppins', sans-serif;
  font-weight: 700;
  font-size: 13.5px;
  margin: 0px 10px 0px 0px;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.principalWhite};

  ${({ tenant }) =>
    tenant &&
    css`
      font-size: 12px;
      font-weight: 500;
      opacity: 0.85;
    `}
`

export const StyledLink = styled(Link)`
  text-decoration: none;

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`
